import z from "zod";

// Base configuration that all agent types share
export const baseAgentConfig = z.object({
});
